module.exports = __webpack_public_path__ + "img/001-owl.cf188012.svg";